import { type FnContext as FnContext } from "~/types/deco";
export function loader(props: Props, _req: Request, ctx: FnContext) {
    return {
        ...props,
        isMobile: ctx.device !== 'desktop',
    };
}
export interface Props {
    /**
     * @title Espaçamento
     * @description Tamanho do espaçamento, e.g. 100px
     */
    size: string;
    /**
     * @title Espaçamento no mobile
     * @description Tamanho do espaçamento, e.g. 100px
     */
    sizeMobile: string;
    /**
     * @ignore
     */
    isMobile: boolean;
}
export default function Space({ size, sizeMobile, isMobile }: Props) {
    if (isMobile) {
        return <div style={{ height: sizeMobile, width: '100%' }}/>;
    }
    return <div style={{ height: size, width: '100%' }}/>;
}

export const sync = true;
